/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The NftGeneratorControllerDtoAddNftUidIndexRequest model module.
 * @module model/NftGeneratorControllerDtoAddNftUidIndexRequest
 * @version 1.0
 */
class NftGeneratorControllerDtoAddNftUidIndexRequest {
    /**
     * Constructs a new <code>NftGeneratorControllerDtoAddNftUidIndexRequest</code>.
     * @alias module:model/NftGeneratorControllerDtoAddNftUidIndexRequest
     */
    constructor() { 
        
        NftGeneratorControllerDtoAddNftUidIndexRequest.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>NftGeneratorControllerDtoAddNftUidIndexRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/NftGeneratorControllerDtoAddNftUidIndexRequest} obj Optional instance to populate.
     * @return {module:model/NftGeneratorControllerDtoAddNftUidIndexRequest} The populated <code>NftGeneratorControllerDtoAddNftUidIndexRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new NftGeneratorControllerDtoAddNftUidIndexRequest();

            if (data.hasOwnProperty('seal')) {
                obj['seal'] = ApiClient.convertToType(data['seal'], 'String');
            }
            if (data.hasOwnProperty('index')) {
                obj['index'] = ApiClient.convertToType(data['index'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>NftGeneratorControllerDtoAddNftUidIndexRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>NftGeneratorControllerDtoAddNftUidIndexRequest</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['seal'] && !(typeof data['seal'] === 'string' || data['seal'] instanceof String)) {
            throw new Error("Expected the field `seal` to be a primitive type in the JSON string but got " + data['seal']);
        }

        return true;
    }


}



/**
 * @member {String} seal
 */
NftGeneratorControllerDtoAddNftUidIndexRequest.prototype['seal'] = undefined;

/**
 * @member {Number} index
 */
NftGeneratorControllerDtoAddNftUidIndexRequest.prototype['index'] = undefined;






export default NftGeneratorControllerDtoAddNftUidIndexRequest;

